var _defs, _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWeRelaxedFace(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1935.95 2000",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #4ad477;\n      }\n\n      .cls-2 {\n        fill: #ffd2c0;\n      }\n\n      .cls-3 {\n        fill: #88e777;\n      }\n\n      .cls-4 {\n        fill: #995222;\n      }\n\n      .cls-5 {\n        fill: #7c3108;\n      }\n\n      .cls-6 {\n        fill: #8c3f0a;\n      }\n\n      .cls-7 {\n        fill: #6d2e03;\n      }\n\n      .cls-8 {\n        fill: #f2ad97;\n      }\n\n      .cls-9 {\n        fill: #c3f9aa;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-1",
    cx: 967.97,
    cy: 1000,
    rx: 967.97,
    ry: 1000
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-3",
    cx: 967.97,
    cy: 1000,
    rx: 829.83,
    ry: 857.29
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-9",
    cx: 967.97,
    cy: 1000,
    rx: 640.22,
    ry: 661.4
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-2",
    cx: 567.61,
    cy: 1189.36,
    rx: 128.96,
    ry: 133.23
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-8",
    cx: 567.61,
    cy: 1189.36,
    rx: 74.11,
    ry: 76.56
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-2",
    cx: 1368.34,
    cy: 1189.36,
    rx: 128.96,
    ry: 133.23
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-8",
    cx: 1368.34,
    cy: 1189.36,
    rx: 74.11,
    ry: 76.56
  }))), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 566.9,
    y: 621,
    width: 802.14,
    height: 976.12,
    rx: 41.76,
    ry: 41.76
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M779.49,1109.96c-26.8,0-52-10.79-70.98-30.4-8.64-8.94-8.64-23.43,0-32.35,8.65-8.94,22.67-8.94,31.32,0,10.6,10.96,24.68,16.99,39.65,16.99s29.05-6.03,39.65-16.99c8.65-8.94,22.67-8.94,31.32,0,8.65,8.93,8.65,23.42,0,32.35-18.97,19.61-44.18,30.4-70.98,30.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M1156.46,1109.96c-26.8,0-52.01-10.79-70.98-30.4-8.64-8.94-8.64-23.43,0-32.35,8.65-8.94,22.67-8.94,31.32,0,10.6,10.96,24.68,16.99,39.65,16.99s29.05-6.03,39.65-16.99c8.65-8.94,22.67-8.94,31.32,0,8.65,8.93,8.65,23.42,0,32.35-18.97,19.61-44.18,30.4-70.98,30.4Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M822.54,470.57c.68,220-118.43,418.91-299.76,520.84-38.36,21.56-85.45-9.47-81.61-54.41,13.04-152.66,78.71-292.39,181.94-390.81,55.78-53.37,122.49-94.52,197.77-119.24,1.07,14.4,1.66,28.91,1.66,43.62Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M1462.19,955.12c-336.2,179.31-758.89-25.36-839.07-408.92,55.46-53.07,121.74-94.05,196.51-118.82,312.57-104.83,624.06,140.92,671.52,469.35,3.43,23.74-8.31,47.38-28.95,58.39Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M1200.28,983.31h0c-57.98,0-115.43-9.28-170.6-27.65-53.72-17.82-104.45-43.88-150.64-77.34-46.01-33.38-86.67-73.41-120.7-119.06-34.76-46.5-61.98-97.78-80.85-152.62-1.64-4.69-1.36-9.75.63-14.25,2.09-4.5,5.72-7.97,10.35-9.66,9.16-3.37,19.87,1.88,23.14,11.34,72.6,210.37,268.97,351.75,488.49,351.75h.18c20.42,0,40.84-1.31,60.71-3.75h0c9.89-1.22,19.05,6.19,20.23,16.31.55,4.97-.73,9.93-3.72,13.87-2.99,3.94-7.35,6.47-12.16,7.03-21.32,2.72-43.28,4.03-65.07,4.03ZM1334.41,965.22c-8.17,0-15.43-5.72-17.51-13.87-2.63-10.03,3.17-20.35,12.79-23.06h.1c1.45-.38,3.08-.56,4.63-.56,8.17,0,15.43,5.62,17.51,13.87,2.63,9.94-3.08,20.16-12.7,22.87,0,.09-.1.09-.1.09-1.54.38-3.17.66-4.71.66Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M1491.14,896.73c-47.46-328.44-358.95-574.18-671.52-469.36-74.76,24.77-141.04,65.76-196.51,118.82,1.49,7.11,3.13,14.13,4.84,21.12,31.56-18.76,65.24-34.37,100.92-46.19,310.46-104.12,619.72,137.66,670.39,462.75,21.23-8.17,42.24-17.73,62.92-28.76,20.64-11.01,32.38-34.65,28.95-58.39Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M1491.14,896.73c-47.46-328.44-358.95-574.18-671.52-469.36-74.76,24.77-141.04,65.76-196.51,118.82.49,2.34,1.05,4.64,1.56,6.97,44.72-33.89,94.84-60.78,149.57-78.92,312.57-104.83,624.06,140.92,671.52,469.36,1,6.9.58,13.75-.83,20.32,5.77-2.83,11.53-5.75,17.26-8.81,20.64-11.01,32.38-34.65,28.95-58.39Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M967.98,1453.3c-41.86,0-83.72-16.46-115.58-49.38-8.65-8.94-8.65-23.42,0-32.35,8.64-8.94,22.68-8.94,31.32,0,46.48,48,122.07,47.99,168.52,0,8.65-8.94,22.67-8.94,31.32,0,8.65,8.94,8.65,23.42,0,32.35-31.87,32.92-73.72,49.38-115.57,49.38Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWeRelaxedFace);
export default __webpack_public_path__ + "static/media/WE - Relaxed Face.3e2f531521fc89e6e8bddcc7050328bf.svg";
export { ForwardRef as ReactComponent };